// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"styles_img-wrapper__XiAD8"};